module.exports = __webpack_public_path__ + "static/media/u.7f5e0861.png";